import React from 'react';
import { Card, CardContent } from '@shadcn/components/ui/card';
import { Bar } from 'react-chartjs-2';

const ChartCard = ({ title, loading, error, chartData, chartOptions, viewType }) => {
  const calculateChartWidth = () => {
    if (!chartData || !chartData.labels) return '100%';
    
    if ((viewType === 'sku' || viewType === 'product') && chartData.labels.length > 10) {
      return `${Math.max(800, chartData.labels.length * 80)}px`;
    }
    
    return '100%';
  };

  return (
    <Card className="mb-6">
      <CardContent className="p-6">
        <h4 className="text-xl font-semibold mb-4">{title}</h4>
        
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="flex flex-col items-center">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
              <span className="mt-2 text-sm text-gray-500">Loading data...</span>
            </div>
          </div>
        ) : error ? (
          <div className="text-center text-red-500 py-6">
            {error}
          </div>
        ) : chartData ? (
          <div className="relative">
            <div className="overflow-x-auto pb-4" style={{ position: 'relative' }}>
              <div style={{ height: '400px', width: calculateChartWidth(), minWidth: '100%' }}>
                <Bar data={chartData} options={chartOptions} />
              </div>
            </div>
            {(viewType === 'sku' || viewType === 'product') && chartData.labels.length > 10 && (
              <div className="text-center mt-2 text-sm text-gray-500">
                <span>← Scroll horizontally to view all data →</span>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-6">
            No data available
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ChartCard;
